import { render, staticRenderFns } from "./HealthPlanTransfer.html?vue&type=template&id=2afeca36&scoped=true&lang=html&external"
import script from "./HealthPlanTransfer.vue?vue&type=script&lang=js"
export * from "./HealthPlanTransfer.vue?vue&type=script&lang=js"
import style0 from "./HealthPlanTransfer.scss?vue&type=style&index=0&id=2afeca36&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afeca36",
  null
  
)

export default component.exports